import { z } from 'zod'

export const getPointAndBenefitInformationSchema = z.object({
  /** 點數 */
  point: z.number(),
  /** 已指派禮遇數量 */
  assignedBenefit: z.number(),
  /** 未指派禮遇數量 */
  notAssignedBenefit: z.number()
})

export interface GetPointAndBenefitInformation
  extends z.infer<typeof getPointAndBenefitInformationSchema> {}
